// ** React Imports
import React, { SyntheticEvent, useEffect, useState } from 'react';

//Agregar el tipo constante y cargarlo

// ** MUI Imports
import Wrapper from '../../../components/Wrapper';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Card from '@mui/material/Card'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import CardActions from '@mui/material/CardActions'
import Alert from '@mui/material/Alert';
import FormControl from '@mui/material/FormControl'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import { TypeConstant } from '../../../models/type_constant';
import InputLabel from '@mui/material/InputLabel'
import HeaderResponsive from '../../../components/layouts/HeaderResponsive';

// ** Third Party Styles Imports
import 'react-datepicker/dist/react-datepicker.css'
import Box from '@mui/material/Box';

import { Link, NavLink, useNavigate, useParams } from 'react-router-dom';
import Title from '../../../components/Title';
import axios from "axios";
import CancelIcon from '@mui/icons-material/Cancel';

interface ShowAlerts {
  showAlert: (message: string, severity?: 'success' | 'info' | 'warning' | 'error') => void;
  showLoading: () => void;
  hideLoading: () => void;
}

const ConstantesEdit: React.FC<ShowAlerts> = ({ showAlert, showLoading, hideLoading }) => {

  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [utility, setUtility] = useState('');
  const [term, setTerm] = useState('');
  const [cloveday, setCloveday] = useState('');
  const [typeConstant, setTypeConstant] = useState([]);
  const [type_constant_id, setTypeConstantid] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [error, setError] = useState('');
  const [showError, setShowError] = useState(false);
  const { id } = useParams();

  useEffect(() => {
    (
      async () => {
        const { data } = await axios.get(`constants/${id}`);
        setName(data.name);
        setUtility(data.utility);
        setTerm(data.term);
        setCloveday(data.cloveday);
        setTypeConstantid(data.type_constant.id)

      }
    )()
  }, []);


  useEffect(() => {
    (
      async () => {
        const { data } = await axios.get('typeconstant');
        setTypeConstant(data.data);
      }
    )();
  }, []);




  const submit = async (event: SyntheticEvent) => {
    event.preventDefault(); // Evita el envío del formulario por defecto
    if (!name || !utility || !term || !cloveday) {
      setError('Tiene campos pendientes por diligenciar');
      setShowError(true);
      return;
    }

    const formData = {
      name,
      utility,
      term,
      cloveday,
      type_constant_id,
    }
    const url = `constants/${id}`
    try {
      const response = await axios.put(url, formData);
      navigate('/administrar/constantes');
      setError('');
      setShowError(false);
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        setErrorMessage(error.response.data.message);
      } else {
        setErrorMessage('An unexpected error occurred.');
      }
      console.error('Error:', error);
    }
  }

  document.title = "Crear Constante  - My Path App";
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <HeaderResponsive>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>

        <Title>Editar Información Constantes</Title>
      </Box>
      <Card>
        <Divider sx={{ margin: 0 }} />
        <Box onSubmit={e => e.preventDefault()} sx={{ mt: 1 }}>
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant='body2' sx={{ fontWeight: 600 }}>
                  Editar Detalles
                </Typography>
              </Grid>
              {showError && (
                <Grid container alignItems="center" justifyContent="center" height="100%">
                  <Grid item xs={12} sm={8} md={5}>
                    <Alert severity="error" onClick={() => setShowError(false)}>
                      {error}
                      <CancelIcon fontSize="inherit" />
                    </Alert>
                  </Grid>
                </Grid>
              )}
              <Grid item xs={12} sm={6}>
                <TextField fullWidth label='Nombre' placeholder='Ingresar nombre' id="name" value={name} onChange={event => setName(event.target.value)} inputProps={{ maxLength: 30 }} required />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth label='Utilidad' placeholder='ingresar utilidad' id="utility" type="number" value={utility} onChange={event => setUtility(event.target.value)} inputProps={{ maxLength: 3 }} required />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth label='Plazo' placeholder='Ingresar plazo' id="term" type="number" value={term} onChange={event => setTerm(event.target.value)} inputProps={{ maxLength: 3 }} required />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth label='Días clavo' placeholder='ingresar días clavo' id="cloveday" type="number" value={cloveday} onChange={event => setCloveday(event.target.value)} inputProps={{ maxLength: 2 }} required />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel id="form-layouts-separator-select-label">
                    Seleccionar Tipo Constante *
                  </InputLabel>
                  {typeConstant && typeConstant.length > 0 ? (
                    <Select
                      label="Tipo Constante "
                      // value="" // Esta línea se asegura de que el Select esté controlado por el estado office_id
                      value={type_constant_id}
                      id="type_constant_id"
                      labelId="type_constant_id"
                      onChange={(event) => setTypeConstantid(event.target.value)}
                      required
                    >
                      {typeConstant.map((typeConstant: TypeConstant) => {
                        return (
                          <MenuItem key={typeConstant.id} value={typeConstant.id}>
                            {typeConstant.name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  ) : null}
                </FormControl>
              </Grid>
            </Grid>
          </CardContent>
        </Box>

        <Divider sx={{ margin: 0 }} />
        <CardActions>
          <Button size='small' type='submit' sx={{ mr: 2 }} variant='contained' onClick={submit}>
            Guardar
          </Button>
          <Link to='/administrar/constantes'>
            <Button size='small' color='secondary' variant='outlined'>
              Cancel
            </Button>
          </Link>
        </CardActions>
      </Card>
    </HeaderResponsive>

  )
}

export default ConstantesEdit

